<template>
  <div class="examples">
    <!-- 左侧导航菜单 start -->
    <div class="examples_left">
      <ul>
        <li
          v-for="(item, index) in exampleName"
          :key="index"
          @click="liChange(index)"
        >
          <div class="leftImg">
            <i :class="item.icon"></i>
          </div>
          <div class="leftText">{{ item.name }}</div>
        </li>
      </ul>
    </div>
    <!-- 左侧导航菜单 end -->

    <!-- 右侧内容 start -->
    <div class="examples_container">
      <div class="examples_content">
        <h3>
          相机
          <span>camera</span>
        </h3>
        <el-row>
          <el-col
            :span="3"
            v-for="(camera, i) in cameras"
            :key="i"
            :offset="1"
          >
            <router-link :to="camera.href">
              <el-card :body-style="{ padding: '0px' }">
                <img
                  :src="camera.img"
                  class="image"
                />
                <div style="text-align: center">
                  <p>{{ camera.name }}</p>
                </div>
              </el-card>
            </router-link>
          </el-col>
        </el-row>
      </div>

      <div class="examples_content">
        <h3>
          信息点
          <span>poi</span>
        </h3>
        <el-row>
          <el-col
            :span="3"
            v-for="(poi, i) in pois"
            :key="i"
            :offset="1"
          >
            <router-link :to="poi.href">
              <el-card :body-style="{ padding: '0px' }">
                <img
                  :src="poi.img"
                  class="image"
                />
                <div style="text-align: center">
                  <p>{{ poi.name }}</p>
                </div>
              </el-card>
            </router-link>
          </el-col>
        </el-row>
      </div>

      <div class="examples_content">
        <h3>
          事件
          <span>event</span>
        </h3>
        <el-row>
          <el-col
            :span="3"
            v-for="(event, i) in events"
            :key="i"
            :offset="1"
          >
            <router-link :to="event.href">
              <el-card :body-style="{ padding: '0px' }">
                <img
                  :src="event.img"
                  class="image"
                />
                <div style="text-align: center">
                  <p>{{ event.name }}</p>
                </div>
              </el-card>
            </router-link>
          </el-col>
        </el-row>
      </div>

      <div class="examples_content">
        <h3>
          矢量
          <span>vector</span>
        </h3>
        <el-row>
          <el-col
            :span="3"
            v-for="(vector, i) in vectors"
            :key="i"
            :offset="1"
          >
            <router-link :to="vector.href">
              <el-card :body-style="{ padding: '0px' }">
                <img
                  :src="vector.img"
                  class="image"
                />
                <div style="text-align: center">
                  <p>{{ vector.name }}</p>
                </div>
              </el-card>
            </router-link>
          </el-col>
        </el-row>
      </div>

      <div class="examples_content">
        <h3>
          轨迹
          <span>track</span>
        </h3>
        <el-row>
          <el-col
            :span="3"
            v-for="(track, i) in tracks"
            :key="i"
            :offset="1"
          >
            <router-link :to="track.href">
              <el-card :body-style="{ padding: '0px' }">
                <img
                  :src="track.img"
                  class="image"
                />
                <div style="text-align: center">
                  <p>{{ track.name }}</p>
                </div>
              </el-card>
            </router-link>
          </el-col>
        </el-row>
      </div>

      <div class="examples_content">
        <h3>
          特效
          <span>effect</span>
        </h3>
        <el-row>
          <el-col
            :span="3"
            v-for="(effect, i) in effects"
            :key="i"
            :offset="1"
          >
            <router-link :to="effect.href">
              <el-card :body-style="{ padding: '0px' }">
                <img
                  :src="effect.img"
                  class="image"
                />
                <div style="text-align: center">
                  <p>{{ effect.name }}</p>
                </div>
              </el-card>
            </router-link>
          </el-col>
        </el-row>
      </div>

      <div class="examples_content">
        <h3>
          轮廓
          <span>outline</span>
        </h3>
        <el-row>
          <el-col
            :span="3"
            v-for="(outline, i) in outlines"
            :key="i"
            :offset="1"
          >
            <router-link :to="outline.href">
              <el-card :body-style="{ padding: '0px' }">
                <img
                  :src="outline.img"
                  class="image"
                />
                <div style="text-align: center">
                  <p>{{ outline.name }}</p>
                </div>
              </el-card>
            </router-link>
          </el-col>
        </el-row>
      </div>

      <div class="examples_content">
        <h3>
          流向图
          <span>flowGraph</span>
        </h3>
        <el-row>
          <el-col
            :span="3"
            v-for="(flow, i) in flows"
            :key="i"
            :offset="1"
          >
            <router-link :to="flow.href">
              <el-card :body-style="{ padding: '0px' }">
                <img
                  :src="flow.img"
                  class="image"
                />
                <div style="text-align: center">
                  <p>{{ flow.name }}</p>
                </div>
              </el-card>
            </router-link>
          </el-col>
        </el-row>
      </div>

      <div class="examples_content">
        <h3>
          图层
          <span>layer</span>
        </h3>
        <el-row>
          <el-col
            :span="3"
            v-for="(layer, i) in layers"
            :key="i"
            :offset="1"
          >
            <router-link :to="layer.href">
              <el-card :body-style="{ padding: '0px' }">
                <img
                  :src="layer.img"
                  class="image"
                />
                <div style="text-align: center">
                  <p>{{ layer.name }}</p>
                </div>
              </el-card>
            </router-link>
          </el-col>
        </el-row>
      </div>

      <div class="examples_content">
        <h3>
          热力图
          <span>hotmap</span>
        </h3>
        <el-row>
          <el-col
            :span="3"
            v-for="(hotmap, i) in hotmaps"
            :key="i"
            :offset="1"
          >
            <router-link :to="hotmap.href">
              <el-card :body-style="{ padding: '0px' }">
                <img
                  :src="hotmap.img"
                  class="image"
                />
                <div style="text-align: center">
                  <p>{{ hotmap.name }}</p>
                </div>
              </el-card>
            </router-link>
          </el-col>
        </el-row>
      </div>

      <div class="examples_content">
        <h3>
          动画
          <span>animation</span>
        </h3>
        <el-row>
          <el-col
            :span="3"
            v-for="(anim, i) in anims"
            :key="i"
            :offset="1"
          >
            <router-link :to="anim.href">
              <el-card :body-style="{ padding: '0px' }">
                <img
                  :src="anim.img"
                  class="image"
                />
                <div style="text-align: center">
                  <p>{{ anim.name }}</p>
                </div>
              </el-card>
            </router-link>
          </el-col>
        </el-row>
      </div>

      <div class="examples_content">
        <h3>
          楼栋
          <span>building</span>
        </h3>
        <el-row>
          <el-col
            :span="3"
            v-for="(building, i) in buildings"
            :key="i"
            :offset="1"
          >
            <router-link :to="building.href">
              <el-card :body-style="{ padding: '0px' }">
                <img
                  :src="building.img"
                  class="image"
                />
                <div style="text-align: center">
                  <p>{{ building.name }}</p>
                </div>
              </el-card>
            </router-link>
          </el-col>
        </el-row>
      </div>

      <div class="examples_content">
        <h3>
          测量
          <span>measure</span>
        </h3>
        <el-row>
          <el-col
            :span="3"
            v-for="(measure, i) in measures"
            :key="i"
            :offset="1"
          >
            <router-link :to="measure.href">
              <el-card :body-style="{ padding: '0px' }">
                <img
                  :src="measure.img"
                  class="image"
                />
                <div style="text-align: center">
                  <p>{{ measure.name }}</p>
                </div>
              </el-card>
            </router-link>
          </el-col>
        </el-row>
      </div>

      <div class="examples_content">
        <h3>
          模型
          <span>model</span>
        </h3>
        <el-row>
          <el-col
            :span="3"
            v-for="(model, i) in models"
            :key="i"
            :offset="1"
          >
            <router-link :to="model.href">
              <el-card :body-style="{ padding: '0px' }">
                <img
                  :src="model.img"
                  class="image"
                />
                <div style="text-align: center">
                  <p>{{ model.name }}</p>
                </div>
              </el-card>
            </router-link>
          </el-col>
        </el-row>
      </div>
      <div class="examples_content">
        <h3>
          昼夜
          <span>dayandnight</span>
        </h3>
        <el-row>
          <el-col
            :span="3"
            v-for="(v, i) in dayandnight"
            :key="i"
            :offset="1"
          >
            <router-link :to="v.href">
              <el-card :body-style="{ padding: '0px' }">
                <img
                  :src="v.img"
                  class="image"
                />
                <div style="text-align: center">
                  <p>{{ v.name }}</p>
                </div>
              </el-card>
            </router-link>
          </el-col>
        </el-row>
      </div>
      <div class="examples_content">
        <h3>
          几何体
          <span>geometry</span>
        </h3>
        <el-row>
          <el-col
            :span="3"
            v-for="(gemo, i) in geoms"
            :key="i"
            :offset="1"
          >
            <router-link :to="gemo.href">
              <el-card :body-style="{ padding: '0px' }">
                <img
                  :src="gemo.img"
                  class="image"
                />
                <div style="text-align: center">
                  <p>{{ gemo.name }}</p>
                </div>
              </el-card>
            </router-link>
          </el-col>
        </el-row>
      </div>

      <div class="examples_content">
        <h3>
          天气
          <span>weather</span>
        </h3>
        <el-row>
          <el-col
            :span="3"
            v-for="(weather, i) in weathers"
            :key="i"
            :offset="1"
          >
            <router-link :to="weather.href">
              <el-card :body-style="{ padding: '0px' }">
                <img
                  :src="weather.img"
                  class="image"
                />
                <div style="text-align: center">
                  <p>{{ weather.name }}</p>
                </div>
              </el-card>
            </router-link>
          </el-col>
        </el-row>
      </div>

      <div class="examples_content">
        <h3>
          其它
          <span>other</span>
        </h3>
        <el-row>
          <el-col
            :span="3"
            v-for="(other, i) in others"
            :key="i"
            :offset="1"
          >
            <router-link :to="other.href">
              <el-card :body-style="{ padding: '0px' }">
                <img
                  :src="other.img"
                  class="image"
                />
                <div style="text-align: center">
                  <p>{{ other.name }}</p>
                </div>
              </el-card>
            </router-link>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 右侧内容 end -->
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "examples",
  data() {
    return {
      cameras: [
        {
          name: "移动",
          href: "./editor?code=camera-look",
          img: "./images/test.jpg",
        },

        {
          name: "定位",
          href: "./editor?code=camera-move",
          img: "./images/test.jpg",
        },
        {
          name: "缩放",
          href: "./editor?code=camera-zoom",
          img: "./images/test.jpg",
        },
        {
          name: "重置",
          href: "./editor?code=camera-reset",
          img: "./images/test.jpg",
        },
        {
          name: "限制",
          href: "./editor?code=camera-restrict",
          img: "./images/test.jpg",
        },
        {
          name: "漫游",
          href: "./editor?code=camera-key",
          img: "./images/test.jpg",
        },
      ],
      pois: [
        {
          name: "标准",
          href: "./editor?code=poi-normal",
          img: "./images/poi_normal.jpg",
        },
        {
          name: "点聚合",
          href: "./editor?code=poi-cluster",
          img: "./images/poi_cluster.jpg",
        },
        {
          name: "区域聚合",
          href: "./editor?code=poi-district-cluster",
          img: "./images/poi_district_cluster.jpg",
        },
      ],
      events: [
        {
          name: "交互",
          href: "./editor?code=event-interaction",
          img: "./images/test.jpg",
        },
        {
          name: "加载完成",
          href: "./editor?code=event-loaded",
          img: "./images/test.jpg",
        },
      ],
      vectors: [
        {
          name: "直线",
          href: "./editor?code=vector-line",
          img: "./images/vector_line.jpg",
        },
        {
          name: "曲线",
          href: "./editor?code=vector-curve",
          img: "./images/vector_curve.jpg",
        },
        {
          name: "矩形",
          href: "./editor?code=vector-rectangle",
          img: "./images/vector_rect.jpg",
        },
        {
          name: "圆",
          href: "./editor?code=vector-circle",
          img: "./images/vector_circle.jpg",
        },
        {
          name: "多边形",
          href: "./editor?code=vector-polygon",
          img: "./images/vector_polygon.jpg",
        },
      ],
      tracks: [
        {
          name: "标准",
          href: "./editor?code=track-normal",
          img: "./images/track_normal.jpg",
        },
      ],
      effects: [
        {
          name: "标准",
          href: "./editor?id=1536283061447032832&code=effect-data",
          img: "./images/effect_data.jpg",
        },
        {
          name: "地标",
          href: "./editor?id=1536283061447032832&code=effect_land_mark1",
          img: "./images/effect_land_mark1.jpg",
        },
        {
          name: "维护",
          href: "./editor?id=1536283061447032832&code=effect_maintain",
          img: "./images/effect_maintain.jpg",
        },
        {
          name: "数据标签",
          href: "./editor?id=1536283061447032832&code=effect-data-show",
          img: "./images/effect_data_show.jpg",
        },
        {
          name: "警告",
          href: "./editor?id=1536283061447032832&code=effetc-alarm",
          img: "./images/effetc_alarm.jpg",
        },
        {
          name: "火",
          href: "./editor?id=1536283061447032832&code=effect_fire",
          img: "./images/effect_fire.jpg",
        },
      ],
      outlines: [
        {
          name: "标准",
          href: "./editor?code=outline-normal",
          img: "./images/outline_normal.jpg",
        },
        {
          name: "圆形轮廓",
          href: "./editor?code=outline-circular",
          img: "./images/outline_circle.jpg",
        },
      ],
      flows: [
        {
          name: "迁徙图",
          href: "./editor?id=1536283061447032832&code=migrate-normal",
          img: "./images/migrate_normal.jpg",
        },
    /*    {
          name: "战略图",
          href: "./editor?code=strategic-normal",
          img: "./images/strategic_normal.jpg",
        },*/
      ],
      layers: [
        {
          name: "标准",
          href: "./editor?code=layer-normal",
          img: "./images/test.jpg",
        },
        {
          name: "高亮",
          href: "./editor?code=layer-highlight",
          img: "./images/layer_highlight.jpg",
        }
      ],
      hotmaps: [
        {
          name: "区域热力",
          href: "./editor?code=heatmap-area",
          img: "./images/heatmap_area.jpg",
        },
        {
          name: "热力路径",
          href: "./editor?code=heatmap-path",
          img: "./images/heatmap_path.jpg",
        },
        {
          name: "柱状热力",
          href: "./editor?code=heatmap-column",
          img: "./images/heatmap_column.jpg",
        },
      ],
      anims: [
        {
          name: "相机动画",
          href: "./editor?code=camera-anim",
          img: "./images/test.jpg",
        },
        {
          name: "模型动画",
          href: "./editor?code=model-anim",
          img: "./images/test.jpg",
        },
      ],
      buildings: [
        {
          name: "展开",
          href: "./editor?id=1536283061447032832&code=building-open",
          img: "./images/building_open.jpg",
        },
      ],
      measures: [
        {
          name: "点",
          href: "./editor?code=measure-point",
          img: "./images/measure_point.jpg",
        },
        {
          name: "距离",
          href: "./editor?code=measure-line",
          img: "./images/mesure_line.jpg",
        },
        {
          name: "面积",
          href: "./editor?code=measure-area",
          img: "./images/measure_area.jpg",
        },
      ],
      models: [
        {
          name: "gltf",
          href: "./editor?code=model-gltf",
          img: "./images/model_gltf.jpg",
        },
      ],
      dayandnight: [
        {
          name: "日景-夜景",
          href: "./editor?id=1536283061447032832&code=dayandnight-day",
          img: "./images/dayandnight_night.jpg",
        },
        {
          name: "夜景-日景",
          href: "./editor?id=1536283061447032832&code=dayandnight-night",
          img: "./images/dayandnight_day.jpg",
        },
      ],
      geoms: [
        {
          name: "立方体",
          href: "./editor?code=geom-cube",
          img: "./images/geom_cube.jpg",
        },
        {
          name: "球体",
          href: "./editor?code=geom-sphere",
          img: "./images/geom_sphere.jpg",
        },
        {
          name: "圆柱体",
          href: "./editor?code=geom-cylinder",
          img: "./images/geom_cylinder.jpg",
        },
        {
          name: "棱柱体",
          href: "./editor?code=geom-prism",
          img: "./images/geom_prism.jpg",
        },
      ],
      weathers: [
        {
          name: "晴天",
          href: "./editor?id=1536283061447032832&code=weather-clear",
          img: "./images/weather_clear.jpg",
        },
        {
          name: "阴天",
          href: "./editor?id=1536283061447032832&code=weather-cloudy",
          img: "./images/weather_cloudy.jpg",
        },
        {
          name: "雨",
          href: "./editor?id=1536283061447032832&code=weather-rain",
          img: "./images/weather_rain.jpg",
        },
        {
          name: "雪",
          href: "./editor?id=1536283061447032832&code=weather-snow",
          img: "./images/weather_snow.jpg",
        },
        {
          name: "雾",
          href: "./editor?id=1536283061447032832&code=weather-fog",
          img: "./images/weather_fog.jpg",
        },
        {
          name: "自定义",
          href: "./editor?id=1536283061447032832&code=weather-custom",
          img: "./images/weather_custom.jpg",
        },
      ],
      others: [
        {
          name: "命令行",
          href: "./editor?code=cmd",
          img: "./images/cmd.jpg",
        },
      ],
      exampleName: [
        {
          name: "相机",
          icon: "el-icon-camera",
        },
        {
          name: "信息点",
          icon: "el-icon-location",
        },
        {
          name: "事件",
          icon: "el-icon-files",
        },
        {
          name: "矢量",
          icon: "el-icon-place",
        },
        {
          name: "轨迹",
          icon: "el-icon-location-information",
        },
        {
          name: "特效",
          icon: "el-icon-magic-stick",
        },
        {
          name: "轮廓",
          icon: "el-icon-full-screen",
        },
        {
          name: "流向图",
          icon: "el-icon-picture-outline",
        },
        {
          name: "图层",
          icon: "el-icon-document-copy",
        },
        {
          name: "热力图",
          icon: "el-icon-pie-chart",
        },
        {
          name: "动画",
          icon: "el-icon-data-analysis",
        },
        {
          name: "楼栋",
          icon: "el-icon-office-building",
        },
        {
          name: "测量",
          icon: "el-icon-edit",
        },
        {
          name: "模型",
          icon: "el-icon-school",
        },
        {
          name: "昼夜",
          icon: "el-icon-sunny",
        },
        {
          name: "几何体",
          icon: "el-icon-help",
        },
        {
          name: "天气",
          icon: "el-icon-cloudy-and-sunny",
        },
        {
          name: "其他",
          icon: "el-icon-menu",
        },
      ],
      liFlag: true,
    };
  },
  methods: {
    liChange(index) {
      if (this.liFlag) {
        this.liFlag = false;
        $(".examples_container").unbind();
        $(".examples_left li").removeClass("liActive");
        $(".examples_left li").eq(index).addClass("liActive");
        $(".examples_container").animate(
          {
            scrollTop: 300 * index,
          },
          200,
          "linear",
          () => {
            this.liFlag = true;
            this.scrollChange();
          }
        );
      }
    },
    scrollChange() {
      $(".examples_container").scroll(function () {
        let tops = parseInt(
          parseInt($(".examples_container").scrollTop()) / 300
        );
        $(".examples_left li").removeClass("liActive");
        $(".examples_left li").eq(tops).addClass("liActive");
      });
    },
  },
  mounted() {
    $(".examples_left li").eq(0).addClass("liActive");
    this.scrollChange();
  },
};
</script>

<style scoped>
.examples {
  width: 100%;
  position: absolute;
  top: 60px;
  bottom: 32px;
}

/* 左侧 start */
.examples_left {
  width: 180px;
  height: 100%;
  position: absolute;
  left: 0;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
}

.examples_left ul {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  user-select: none;
  overflow-y: auto;
}

li {
  height: 40px;
  padding: 5px 25px;
  border-right: 4px solid transparent;
  list-style-type: none;
  font-size: 16px;
  color: #6e7079;
  letter-spacing: 1px;
  line-height: 40px;
  text-align: center;
  display: flex;
  align-items: center;
  /* justify-content: space-around; */
}

.liActive {
  color: #fff;
  background-color: #5470c6;
}

.leftImg {
  font-size: 20px;
  line-height: 40px;
  margin-left: 15px;
  margin-right: 15px;
}

.examples_left li:hover {
  border-right: 4px solid #5470c6;
}

.examples_left ul::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 7px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.examples_left ul::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #d6d6d6;
}
/* .examples_left ul::-webkit-scrollbar-track { */
/*滚动条里面轨道*/
/* box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
} */

/* 左侧 end */

.examples_container {
  overflow-y: scroll;
  width: calc(100% - 180px);
  height: 100%;
  position: absolute;
  right: 0;
}

.examples_container::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 8px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.examples_container::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #d6d6d6;
}

.examples_content {
  position: relative;
  height: 260px;
  margin: 40px;
}

.examples_content h3 {
  border-bottom: 1px solid #e1e5f2;
  font-weight: normal;
  color: #464646;
  font-size: 20px;
}

.examples_content span {
  font-size: 16px;
  padding-left: 5px;
  color: #949cb1;
  font-weight: 200;
}

.examples_content a {
  text-decoration: none;
}

.examples_content p {
  color: #293c55;
}

.examples_content a :hover {
  text-decoration: underline;
}

.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.image {
  position: relative;
  left: 3px;
  height: 160px;
  width: 220px;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>
